function EthIcon() {
  return (
    <svg style={{ width: "16px", height: "16px" }} viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M12,1.75L5.75,12.25L12,16L18.25,12.25L12,1.75M5.75,13.5L12,22.25L18.25,13.5L12,17.25L5.75,13.5Z"
      />
    </svg>
  );
}

export default EthIcon;
